module.exports = __webpack_public_path__ + "static/media/curadoria.3d024802.svg";